import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "./Store";
import { Subscription } from "./Types/SubscriptionInterface";
import { UserType } from "./Types/UserTypeInterface";

const selectUserTypes = (state: RootState) => state.userTypes.userTypes;
const selectPlans = (state: RootState) => state.subscriptions.subscriptions;

export const selectMappedUserType = createSelector(
    [selectPlans, selectUserTypes],
    (planList: Subscription[], userTypes: UserType[]) => {
        return userTypes.map((userType) => ({
            ...userType,
            plans: planList.filter((plan) => plan.user_type_id === userType.id),
        }));
    }
);